import React, { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import apiV2 from '../../../services/apiV2';

// Resolve membership as well as carrying context: older preview bookmarks have no unit ID.
export function PreviewUnitReturnLink({ planId }: { planId: number }) {
  const [params] = useSearchParams();
  const [units, setUnits] = useState<any[]>([]);
  useEffect(() => {
    let active = true;
    setUnits([]);
    apiV2.get('/curriculum/library/').then(({ data }) => {
      if (active) setUnits((data.units || []).filter((unit: any) =>
        unit.modules.some((module: any) => module.lessons.some((lesson: any) => lesson.plan_id === planId))));
    }).catch(() => { /* The existing Back to Plan link remains available. */ });
    return () => { active = false; };
  }, [planId]);
  const unit = units.find(candidate => String(candidate.id) === params.get('unit'))
    || (units.length === 1 ? units[0] : null);
  if (!unit) return null;
  const modules = unit.modules.filter((module: any) => module.lessons.some((lesson: any) => lesson.plan_id === planId));
  const module = modules.find((candidate: any) => String(candidate.id) === params.get('module')) || modules[0];
  const query = new URLSearchParams({ view: 'units', unit: String(unit.id), module: String(module.id) });
  const section = params.get('section');
  if (section) query.set('section', section);
  return <Link className="inline-block font-semibold underline" to={`/v2/teacher/plan?${query}`}>
    ← Back to unit: {unit.title}
  </Link>;
}
